<template>
  <div class="vip-detail-container">
    <div class="white-bg padding-left padding-right padding-top border-radius-top">
      <div class="flex justify-between">
        <div class="text-title">
          {{ $t('vipDetail.title') }}
        </div>
        <div></div>
      </div>

      <!-- 会员信息 -->
      <div class="margin-top text-left">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                {{ $t('vipDetail.vipId') }}
              </label>
              <label>{{ vipDetailInfo.vipId }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                {{ $t('vipDetail.vipName') }}
              </label>
              <label>{{ vipDetailInfo.vipName || '-' }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                {{ $t('vipDetail.vipTel') }}
              </label>
              <label>{{ vipDetailInfo.vipTel }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                {{ $t('vipDetail.sex') }}
              </label>
              <label>{{ vipDetailInfo.sex == '0' ? $t('common.female') : $t('common.male') }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                {{ $t('vipDetail.levelName') }}
              </label>
              <label>{{ vipDetailInfo.levelName || '-' }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                {{ $t('vipDetail.birthday') }}
              </label>
              <label>{{ vipDetailInfo.birthday || '-' }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                {{ $t('vipDetail.startTime') }}
              </label>
              <label>{{ vipDetailInfo.startTime || '-' }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                {{ $t('vipDetail.endTime') }}
              </label>
              <label>{{ vipDetailInfo.endTime || '-' }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                {{ $t('vipDetail.createTime') }}
              </label>
              <label>{{ vipDetailInfo.createTime || '-' }}</label>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="vc-line-primary margin-top"></div>

      <div class="margin-top-sm">
        <el-tabs v-model="vipDetailInfo._currentTab" @tab-click="changeTab(vipDetailInfo._currentTab)">
          <el-tab-pane :label="$t('vipDetail.vipDetailUser')" name="vipDetailUser"></el-tab-pane>
          <el-tab-pane :label="$t('vipDetail.vipDetailAccount')" name="vipDetailAccount"></el-tab-pane>
          <el-tab-pane :label="$t('vipDetail.vipDetailIntegral')" name="vipDetailIntegral"></el-tab-pane>
          <el-tab-pane :label="$t('vipDetail.vipDetailIntegralDetail')" name="vipDetailIntegralDetail"></el-tab-pane>
          <el-tab-pane :label="$t('vipDetail.vipDetailOrder')" name="vipDetailOrder"></el-tab-pane>
          <el-tab-pane :label="$t('vipDetail.vipDetailRefundOrder')" name="vipDetailRefundOrder"></el-tab-pane>
          <el-tab-pane :label="$t('vipDetail.vipDetailGroupOrders')" name="vipDetailGroupOrders"></el-tab-pane>
          <el-tab-pane :label="$t('vipDetail.vipDetailRefundGroupOrders')"
            name="vipDetailRefundGroupOrders"></el-tab-pane>
          <el-tab-pane :label="$t('vipDetail.vipDetailSeckillOrders')" name="vipDetailSeckillOrders"></el-tab-pane>
          <el-tab-pane :label="$t('vipDetail.vipDetailAddress')" name="vipDetailAddress"></el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div class="white-bg padding-left padding-right border-radius-bottom">
      <vip-detail-user v-if="vipDetailInfo._currentTab === 'vipDetailUser'" ref="vipDetailUser"></vip-detail-user>
      <vip-detail-account v-if="vipDetailInfo._currentTab === 'vipDetailAccount'" ref="vipDetailAccount"></vip-detail-account>
      <vip-detail-integral v-if="vipDetailInfo._currentTab === 'vipDetailIntegral'" ref="vipDetailIntegral"></vip-detail-integral>
      <vip-detail-integral-detail
        v-if="vipDetailInfo._currentTab === 'vipDetailIntegralDetail'" ref="vipDetailIntegralDetail"></vip-detail-integral-detail>
      <vip-detail-order v-if="vipDetailInfo._currentTab === 'vipDetailOrder'" ref="vipDetailOrder"></vip-detail-order>
      <vip-detail-refund-order v-if="vipDetailInfo._currentTab === 'vipDetailRefundOrder'" ref="vipDetailRefundOrder"></vip-detail-refund-order>
      <vip-detail-group-orders v-if="vipDetailInfo._currentTab === 'vipDetailGroupOrders'" ref="vipDetailGroupOrders"></vip-detail-group-orders>
      <vip-detail-refund-group-orders
        v-if="vipDetailInfo._currentTab === 'vipDetailRefundGroupOrders'" ref="vipDetailRefundGroupOrders"></vip-detail-refund-group-orders>
      <vip-detail-seckill-orders
        v-if="vipDetailInfo._currentTab === 'vipDetailSeckillOrders'" ref="vipDetailSeckillOrders"></vip-detail-seckill-orders>
      <vip-detail-address v-if="vipDetailInfo._currentTab === 'vipDetailAddress'" ref="vipDetailAddress"></vip-detail-address>
    </div>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import VipDetailUser from '@/components/user/vipDetailUser/vipDetailUser'
import VipDetailAccount from '@/components/user/vipDetailAccount/vipDetailAccount'
import VipDetailIntegral from '@/components/user/vipDetailIntegral/vipDetailIntegral'
import VipDetailIntegralDetail from '@/components/user/vipDetailIntegralDetail/vipDetailIntegralDetail'
import VipDetailOrder from '@/components/user/vipDetailOrder/vipDetailOrder'
import VipDetailRefundOrder from '@/components/user/vipDetailRefundOrder/vipDetailRefundOrder'
import VipDetailGroupOrders from '@/components/user/vipDetailGroupOrders/vipDetailGroupOrders'
import VipDetailRefundGroupOrders from '@/components/user/vipDetailRefundGroupOrders/vipDetailRefundGroupOrders'
import VipDetailSeckillOrders from '@/components/user/vipDetailSeckillOrders/vipDetailSeckillOrders'
import VipDetailAddress from '@/components/user/vipDetailAddress/vipDetailAddress'
import { getShopVipUser } from '@/api/user/vipDetailApi'

export default {
  name: 'VipDetail',
  components: {
    VipDetailUser,
    VipDetailAccount,
    VipDetailIntegral,
    VipDetailIntegralDetail,
    VipDetailOrder,
    VipDetailRefundOrder,
    VipDetailGroupOrders,
    VipDetailRefundGroupOrders,
    VipDetailSeckillOrders,
    VipDetailAddress
  },
  data() {
    return {
      vipDetailInfo: {
        vipId: '',
        vipName: '',
        vipTel: '',
        sex: '',
        levelName: '',
        birthday: '',
        startTime: '',
        endTime: '',
        createTime: '',
        _currentTab: 'vipDetailUser'
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    this.vipDetailInfo.vipId = this.$route.query.vipId || ''
    if (this.vipDetailInfo.vipId) {
      this.listShopVipUsers()
    }
  },
  methods: {
    listShopVipUsers() {
      const params = {
        vipId: this.vipDetailInfo.vipId,
        page: 1,
        row: 1,
        shopId: this.shopId
      }

      getShopVipUser(params).then(res => {
        if (res.data && res.data.length > 0) {
          Object.assign(this.vipDetailInfo, res.data[0])
        }
      }).catch(err => {
        console.error('获取会员信息失败:', err)
      })
    },
    changeTab(tab) {
      this.vipDetailInfo._currentTab = tab
      setTimeout(() => {
        this.$refs[tab].open({
          vipId: this.vipDetailInfo.vipId,
          vipName: this.vipDetailInfo.vipName,
          tel: this.vipDetailInfo.vipTel,
        })
      }, 100)
    }
  }
}
</script>

<style scoped>
.vip-detail-container {
  background-color: #f5f7fa;
}

.white-bg {
  background-color: #fff;
}

.padding-left {
  padding-left: 20px;
}

.padding-right {
  padding-right: 20px;
}

.padding-top {
  padding-top: 20px;
}

.border-radius-top {
  border-radius: 4px 4px 0 0;
}

.border-radius-bottom {
  border-radius: 0 0 4px 4px;
}

.margin-top {
  margin-top: 20px;
}

.margin-top-sm {
  margin-top: 10px;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.text-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.form-group {
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
}

.col-form-label {
  display: block;
  margin-bottom: 5px;
  color: #606266;
}
</style>